import { render, staticRenderFns } from "./buyTicketRecord.vue?vue&type=template&id=3d03e20e&scoped=true"
import script from "./buyTicketRecord.vue?vue&type=script&lang=js"
export * from "./buyTicketRecord.vue?vue&type=script&lang=js"
import style0 from "./buyTicketRecord.vue?vue&type=style&index=0&id=3d03e20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d03e20e",
  null
  
)

export default component.exports